import Vue from "vue"
import VueI18n from "vue-i18n"

Vue.use(VueI18n)

const messages = {
    en: {
        partTime: 'Parttime91',
        allTasks: 'All Tasks',
        myTasks: 'My Tasks',
        taskAvailable: 'Tasks Available',
        taskAvailable: 'Task Available',
        perTask: 'per task',
        leaderShipBoard: 'Leadership Board',
        viewetail: 'View Details',
        pendingTasks: 'Tasks Pending',
        task: 'task',
        completed: 'Completed',
        status: 'Status',
        payment: 'Payment',
        seeSubmission: 'See Submission',
        contentReviewer: 'Content Reviewer',
        leaderBoard: 'Leaderboard',
        totalEarning: 'Total Earning',
        taskCompleted: 'Task Completed',
        profile: 'Profile',
        inWallet: 'in Wallet',
        fullName: 'Full Name',
        mobileNumber: 'Mobile Number',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        tellAboutYouself: 'Write about your self',
        writeHere: 'Write Here...',
        address: 'Full Address',
        skills: 'Skills',
        updateYourProfile: 'Update your profile',
        submitYourTask: 'Submit Your Task',
        addATitle: 'Add a Title',
        writeTaskTitle: 'write task title',
        comments: 'Comments',
        optional: 'Optional',
        uploadAPhotoOrVideo: 'Upload file',
        supportFormat: 'Support format:',
        taskDetail: 'Task Details',
        earning: 'Earning',
        perTaskCompleted: 'per task completed',
        totalMoneyEarned: 'Total Money Earned',
        totalAvailableTask: 'Total Available Tasks',
        totalCompletedTask: 'Total Completed Tasks',
        howToCompleteTasks: 'How to complete your task',
        seeInvideo: 'See in Video',
        acceptThisTask: 'Accept this Task',
        rejectThisTask: 'Reject this Task',
        editedProfileSuccefully: 'Updated your profile succefully',
        enterAllFeilds: 'Please enter all required details',
        enterValidName: 'Please enter valid name!',
        enterValidMobileNumber: 'Please enter your valid mobile number !',
        enterValidAddress: 'Please enter your valid address !',
        enterValidPinNumber: 'Please enter valid pincode !',
        congrats: 'Congratulation',
        taskUploadedSuccessfully: 'Your task uploaded successfully !',
        doYouReallyWantToAccept: 'Do you want to accept this task?',
        doYouReallyWantToSumbit: 'Do you want to submit this task?',
        yes: 'Yes',
        no: 'No',
        later: 'Later',
        updateYourSkill: 'Please update your profile to continue',
        notUpdatedYourTask: 'Because of some reason did not complete your task, please try again.',
        toProceedPleaseUpdateProfile: "Please update skills on profile to proceed with task acceptance",
        userNotAuthorized: 'user not authorized',
        alreadyAccepted: 'Already accepted',
        taskCompletionTime: 'Task completion time',
        goToProduct: 'Go to task',
        getTask: 'Get Task',
        paymentSuccessFull: 'Payment Successfull !',
        paymentUnSuccessFull: 'Payment Failed !',
        orderDetail: 'Order detail',
        name: 'Full Name',
        OrderId: 'Order Id',
        productName: 'Product Name',
        phoneNumber: 'Mo.Number',
        amount: 'Amount',
        address: 'Address',
        pincode: 'Pincode',
        city: 'City',
        state: 'State',
        postOffice: 'Post Office',
        makecall: 'Make call',
        callconnectMsg: 'Please wait while connecting call. Call will be initiated by this number {phoneNumber}.',
        orderAcceptedOrRejected: 'Customer has accepted or rejected this order ?',
        orderAccepted: 'Order Accepted',
        orderDenied: 'Order Denied',
        payRegisterationFees: 'Pay registration fees',
        retry: 'Retry',
        orderStatus: 'Order status',
        callCompletedOrRejected: 'Order call has been completed or not ?',
        callCompleted: 'Call completed',
        callNotCompleted: 'Call not completed',
        callNotPicked: 'Call not picked',
        getNextTask: 'Get next task',
        noMoreRecord:'No more record',
        getTaskAllowedMsg: 'This task can be performed from 9AM till 8PM only.',
        paymentMode: 'Payment Mode',
        newTaskWillBeAvailable: 'New tasks would be available in some time.',
        appBalanceChecked: 'App balance checked',
        appBalanceNotChecked: 'App balance not checked',
        walletBalance: 'Wallet Balance',
        mPointBalance: 'MPoints Balance',
        userDetail: 'User Detail',
        notAvailable: 'Not Available',
        gameDownload: 'Will Download',
        gameNotDownload: 'Will not Download',
        choosePaymentOption: 'Choose payment option',
        fillRegistrationForm: 'Fill Registration form',
        registered: 'Registered',
        mall91AgentWillCallYou: 'Congratulations!! We have received your details. Mall91 Agent would contact you soon!',
        supportedPincode: 'Supported Pincode'
    },
    hi: {
        partTime: 'पार्ट टाइम 91',
        allTasks: 'सभी टास्क',
        myTasks: 'मेरे टास्क',
        taskAvailable: 'उपलब्ध टास्क',
        taskAvailable: 'उपलब्ध टास्क',
        perTask: 'प्रति टास्क',
        leaderShipBoard: 'लीडरशिप बोर्ड',
        viewetail: 'विवरण देखें',
        pendingTasks: 'टास्क पेंडिंग',
        task: 'टास्क',
        completed: 'पूरा कर लिया है',
        status: 'स्थिति',
        payment: 'पेमेंट ',
        seeSubmission: 'प्रस्तुत करें',
        contentReviewer: 'सामग्री समीक्षक',
        leaderBoard: 'लीडरबोर्ड',
        totalEarning: 'Total Earning',
        taskCompleted: 'टास्क संपूर्ण हुआ',
        profile: 'प्रोफ़ाइल',
        inWallet: 'वॉलेट में',
        fullName: 'पूरा नाम',
        mobileNumber: 'मोबाइल नंबर',
        gender: 'जेंडर',
        male: 'पुरुष',
        female: 'महिला',
        tellAboutYouself: 'अपने बारे में लिखें',
        writeHere: 'यहाँ लिखें...',
        address: 'पता',
        skills: 'स्किल्स',
        updateYourProfile: 'प्रोफाइल अपडेट करें',
        submitYourTask: 'अपना टास्क सबमिट करें',
        addATitle: 'टास्क का टाइटल लिखें ',
        writeTaskTitle: 'टास्क शीर्षक लिखें',
        comments: '',
        optional: '',
        uploadAPhotoOrVideo: 'फाइल अपलोड करें',
        supportFormat: 'समर्थन प्रारूप:',
        taskDetail: 'टास्क विवरण',
        earning: 'कमाई',
        perTaskCompleted: 'प्रति टास्क पूरा हुआ',
        totalMoneyEarned: '',
        totalAvailableTask: 'कुल उपलब्ध टास्क',
        totalCompletedTask: 'कुल पूर्ण टास्क',
        howToCompleteTasks: 'अपना टास्क कैसे पूरा करें',
        seeInvideo: 'वीडियो में देखें',
        acceptThisTask: 'इस टास्क को स्वीकार करें',
        rejectThisTask: 'इस टास्क को अस्वीकार करें',
        editedProfileSuccefully: 'आपके प्रोफ़ाइल को सफलतापूर्वक अपडेट किया गया।',
        enterAllFeilds: 'कृपया जारी रखने के लिए सभी फ़ील्ड ठीक से भरें',
        enterValidName: 'कृपया मान्य नाम दर्ज करें !',
        enterValidMobileNumber: 'कृपया मान्य मोबाइल नंबर दर्ज करें !',
        enterValidAddress: 'कृपया मान्य पता दर्ज करें !',
        enterValidPinNumber: 'कृपया मान्य पिन कोड दर्ज करें !',
        congrats: 'बधाई हो!',
        taskUploadedSuccessfully: 'आपका टास्क सफलतापूर्वक अपलोड किया गया !',
        doYouReallyWantToAccept: 'क्या आप इस टास्क को स्वीकार करना चाहते हैं?',
        doYouReallyWantToSumbit: 'क्या आप यह टास्क सबमिट करना चाहते हैं?',
        yes: 'हाँ',
        no: 'नहीं',
        later: 'बाद में',
        updateYourSkill: 'कृपया जारी रखने के लिए प्रोफाइल अपडेट करें',
        notUpdatedYourTask: 'किसी कारण्डवाश आपका टास्क पूरा नहीं हुआ , कृपया पुनः प्रयास करें |',
        toProceedPleaseUpdateProfile: 'टास्क स्वीकृति के साथ आगे बढ़ने के लिए कृपया प्रोफ़ाइल पर स्किल्स अपडेट करें',
        userNotAuthorized: 'user not authorized',
        alreadyAccepted: 'Already accepted',
        taskCompletionTime: 'टास्क पूरा करने का समय ',
        goToProduct: 'टास्क पर जाएं ',
        getTask: 'टास्क पर जाएं',
        paymentSuccessFull: 'भुगतान सफल हुआ !',
        paymentUnSuccessFull: 'भुगतान असफल हुआ !',
        orderDetail: 'आर्डर डिटेल',
        name: 'पूरा नाम',
        OrderId: 'आर्डर Id',
        productName: 'प्रोडक्ट नाम',
        phoneNumber: 'मो. नंबर ',
        amount: 'अमाउंट',
        address: 'पूरा एड्रेस',
        pincode: 'पिनकोड',
        city: 'शहर',
        state: 'राज्य',
        postOffice: 'डाक घर',
        makecall: 'कॉल करें ',
        callconnectMsg: 'कृपया कॉल कनेक्ट होने की प्रतीक्षा करें | कॉल आपके {phoneNumber}} नंबर से जारी होगी|',
        orderAcceptedOrRejected: 'यह सामन ग्राहक के द्वारा स्वीकार किया गया या अस्वीकार किया गया ?',
        orderAccepted: 'आर्डर स्वीकार हुआ',
        orderDenied: 'आर्डर अस्वीकार हुआ',
        payRegisterationFees: 'रजिस्ट्रेशन के लिए भुगतान करें',
        retry: 'पुनः प्रयास करें',
        orderStatus: 'आर्डर की स्तिथि ',
        callCompletedOrRejected: 'ऑर्डर कॉल पूरा हो गया है या नहीं ?',
        callCompleted: 'कॉल पूरा हुआ',
        callNotCompleted: 'कॉल पूरा नहीं हुआ',
        callNotPicked: 'कॉल नहीं उठाया',
        getNextTask: 'अगले टास्क पर जाएं',
        noMoreRecord: 'और रिकॉर्ड उपलब्ध नहीं है',
        getTaskAllowedMsg: 'यह टास्क सुबह 9 बजे से शाम 8 बजे तक ही प्राप्त किया जा सकता है|',
        paymentMode: 'भुगतान का प्रकार',
        newTaskWillBeAvailable: 'नया टास्क कुछ समय में उपलब्ध होगा।',
        appBalanceChecked: 'ऍप बैलेंस चेक हो गया।',
        appBalanceNotChecked: 'ऍप बैलेंस नहीं चेक हुआ।',
        walletBalance: 'वॉलेट बैलेंस',
        mPointBalance: 'MPoints बैलेंस',
        userDetail: 'यूजर डिटेल',
        notAvailable: 'उपलब्ध नहीं है',
        gameDownload: 'डाउनलोड करेगा',
        gameNotDownload: 'डाउनलोड नहीं करेगा',
        choosePaymentOption: 'भुगतान का विकल्प चुनें',
        fillRegistrationForm: 'रजिस्ट्रेशन फॉर्म भरें',
        registered: 'Registered',
        mall91AgentWillCallYou: 'बधाई हो!! हमें आपका विवरण मिल गया है। Mall91 एजेंट जल्द ही आपसे संपर्क करेंगे!',
        supportedPincode: 'समर्थित पिनकोड'
    },

    bn: {
        partTime: 'পার্ট টাইম 91',
        allTasks: 'সমস্ত কাজ',
        myTasks: 'আমার কাজ',
        taskAvailable: 'টাস্ক উপলব্ধ',
        taskAvailable: 'টাস্ক উপলব্ধ',
        perTask: 'প্রতি কাজ',
        leaderShipBoard: 'নেতৃত্ব বোর্ড',
        viewetail: 'বিস্তারিত দেখুন',
        pendingTasks: 'বিচারাধীন কাজগুলি',
        task: 'কাজের',
        completed: 'সম্পন্ন',
        status: 'অবস্থা',
        payment: 'পারিশ্রমিক',
        seeSubmission: 'জমা দেখুন',
        contentReviewer: 'বিষয়বস্তু পর্যালোচক',
        leaderBoard: 'লিডারবোর্ড',
        totalEarning: '',
        taskCompleted: 'কাজ সম্পূর্ণ',
        profile: 'প্রোফাইল',
        inWallet: 'ওয়ালেটে',
        fullName: 'পুরো নাম',
        mobileNumber: 'মোবাইল নম্বর',
        gender: 'লিঙ্গ',
        male: 'পুরুষ',
        female: 'মহিলা',
        tellAboutYouself: 'তোমার সম্পর্কে লেখ',
        writeHere: 'এখানে লিখ...',
        address: 'ঠিকানা',
        skills: 'দক্ষতা',
        updateYourProfile: 'আপনার প্রোফাইল আপডেট করুন',
        submitYourTask: 'আপনার টাস্ক জমা দিন',
        addATitle: 'একটি শিরোনাম যুক্ত করুন',
        writeTaskTitle: 'টাস্ক শিরোনাম লিখুন',
        comments: '',
        optional: '',
        uploadAPhotoOrVideo: 'ফাইল আপলোড করুন',
        supportFormat: 'সমর্থন বিন্যাস:',
        taskDetail: 'কার্য বিবরণ',
        earning: 'রোজগার',
        perTaskCompleted: 'প্রতি কাজ শেষ',
        totalMoneyEarned: '',
        totalAvailableTask: 'মোট উপলব্ধ টাস্ক',
        totalCompletedTask: 'মোট কাজ শেষ',
        howToCompleteTasks: 'কীভাবে আপনার কাজটি শেষ করবেন',
        seeInvideo: 'ভিডিওতে দেখুন',
        acceptThisTask: 'এই কার্যটি গ্রহণ করুন',
        rejectThisTask: 'এই কার্যটি প্রত্যাখ্যান করুন',
        editedProfileSuccefully: 'আপনার প্রোফাইল সফলভাবে আপডেট হয়েছে',
        enterAllFeilds: 'সমস্ত প্রয়োজনীয় বিবরণ প্রবেশ করুন',
        enterValidName: 'বৈধ নাম লিখুন!',
        enterValidMobileNumber: 'আপনার বৈধ মোবাইল নম্বর লিখুন!',
        enterValidAddress: 'আপনার বৈধ ঠিকানা লিখুন!',
        enterValidPinNumber: 'বৈধ পিনকোড প্রবেশ করুন!',
        congrats: 'অভিনঁদন',
        taskUploadedSuccessfully: 'আপনার কাজটি সফলভাবে আপলোড হয়েছে!',
        doYouReallyWantToAccept: 'আপনি কি এই কাজটি গ্রহণ করতে চান?',
        doYouReallyWantToSumbit: 'আপনি কি এই কাজটি জমা দিতে চান?',
        yes: 'হ্যাঁ',
        no: 'না',
        later: 'পরবর্তীতে',
        updateYourSkill: 'Please update your profile to continue',
        notUpdatedYourTask: 'Because of some reason did not complete your task, please try again.',
        toProceedPleaseUpdateProfile: "টাস্ক গ্রহণযোগ্যতা নিয়ে এগিয়ে যাওয়ার জন্য দয়া করে প্রোফাইলে দক্ষতা আপডেট করুন",
        userNotAuthorized: 'user not authorized',
        alreadyAccepted: 'Already accepted',
        taskCompletionTime: 'কার্য সমাপ্তির সময়',
        goToProduct: 'কাজে যান to',
        getTask: 'টাস্ক পান',
        paymentSuccessFull: 'অর্থ প্রদান সফল !',
        paymentUnSuccessFull: 'পেমেন্ট ব্যর্থ হয়েছে!',
        orderDetail: 'আদেশ বিবরণী',
        name: 'পুরো নাম',
        OrderId: 'ক্রম Id',
        productName: 'পণ্যের নাম',
        phoneNumber: 'মোবাইল নম্বর',
        amount: 'পরিমাণ',
        address: 'পুরো ঠিকানা',
        pincode: 'পিনকোড',
        city: 'শহর',
        state: 'অবস্থা',
        postOffice: 'ডাক ঘর',
        makecall: 'কল কর',
        callconnectMsg: 'Please wait while connecting call. Call will be initiated by this number {phoneNumber}.',
        orderAcceptedOrRejected: 'গ্রাহক এই আদেশ গ্রহণ করেছেন বা প্রত্যাখ্যান করেছেন?',
        orderAccepted: 'অর্ডার গৃহীত',
        orderDenied: 'আদেশ অস্বীকার করা হয়েছে',
        payRegisterationFees: 'নিবন্ধন ফি প্রদান করুন',
        retry: 'Retry',
        orderStatus: 'অর্ডারের অবস্থা',
        callCompletedOrRejected: 'কল অন অর্ডার সম্পন্ন হয়েছে কি না?',
        callCompleted: 'কল শেষ হয়েছে',
        callNotCompleted: 'কল শেষ হয়নি',
        callNotPicked: 'কল পিক না',
        getNextTask: 'পরবর্তী কাজ পান',
        noMoreRecord: 'আর রেকর্ড নেই',
        getTaskAllowedMsg: 'এই টাস্কটি সকাল 9 টা থেকে 8 পিএম পর্যন্ত সম্পাদিত হতে পারে',
        paymentMode: 'পরিশোধের মাধ্যম',
        newTaskWillBeAvailable: 'নতুন টাস্কটি কিছু সময়ের মধ্যে পাওয়া যাবে।',
        appBalanceChecked: 'অ্যাপ্লিকেশন ব্যালেন্স চেক করা হয়েছে',
        appBalanceNotChecked: 'অ্যাপ্লিকেশন ব্যালেন্স চেক করা হয়নি',
        walletBalance: 'মানিব্যাগ ভারসাম্য',
        mPointBalance: 'MPoints ভারসাম্য',
        userDetail: 'ব্যবহারকারী বিশদ',
        notAvailable: 'পাওয়া যায় না',
        gameDownload: 'ডাউনলোড করবে',
        gameNotDownload: 'ডাউনলোড করবে না',
        choosePaymentOption: 'Choose payment option',
        fillRegistrationForm: 'Fill Registration form',
        registered: 'Registered',
        mall91AgentWillCallYou: 'Congratulations!! We have received your details. Mall91 Agent would contact you soon!',
        supportedPincode: 'Supported Pincode'

    },
    gu: {
        partTime: 'ભાગ સમય 91',
        allTasks: 'બધા કાર્યો',
        myTasks: 'મારા કાર્યો',
        taskAvailable: 'ઉપલબ્ધ કાર્યો',
        taskAvailable: 'કાર્ય ઉપલબ્ધ છે',
        perTask: 'કાર્ય દીઠ',
        leaderShipBoard: 'લીડરશીપ બોર્ડ',
        viewetail: 'વિગતો જુઓ',
        pendingTasks: 'બાકી કાર્યો',
        task: 'કાર્ય',
        completed: 'પૂર્ણ',
        status: 'સ્થિતિ',
        payment: 'ચુકવણી',
        seeSubmission: 'સબમિશન જુઓ',
        contentReviewer: 'સામગ્રી સમીક્ષા કરનાર',
        leaderBoard: 'લીડરબોર્ડ',
        totalEarning: '',
        taskCompleted: 'কাজ সম্পূর্ণ',
        profile: 'પ્રોફાઇલ',
        inWallet: 'વletલેટ માં',
        fullName: 'પૂરું નામ',
        mobileNumber: 'મોબાઇલ નંબર',
        gender: 'લિંગ',
        male: 'પુરુષ',
        female: 'સ્ત્રી',
        tellAboutYouself: 'તમારા સ્વ વિશે લખો',
        writeHere: 'અહીં લખો ...',
        address: 'સરનામું',
        skills: 'કુશળતા',
        updateYourProfile: 'તમારી પ્રોફાઇલ અપડેટ કરો',
        submitYourTask: 'તમારું કાર્ય સબમિટ કરો',
        addATitle: 'એક શીર્ષક ઉમેરો',
        writeTaskTitle: 'કાર્ય શીર્ષક લખો',
        comments: '',
        optional: '',
        uploadAPhotoOrVideo: 'ફાઇલ અપલોડ કરો',
        supportFormat: 'સપોર્ટ ફોર્મેટ:',
        taskDetail: 'કાર્ય વિગતો',
        earning: 'કમાણી',
        perTaskCompleted: 'દીઠ કાર્ય પૂર્ણ',
        totalMoneyEarned: '',
        totalAvailableTask: 'કુલ ઉપલબ્ધ કાર્યો',
        totalCompletedTask: 'કુલ પૂર્ણ કાર્યો',
        howToCompleteTasks: 'તમારા કાર્યને કેવી રીતે પૂર્ણ કરવું',
        seeInvideo: 'વિડિઓમાં જુઓ',
        acceptThisTask: 'આ કાર્ય સ્વીકારો',
        rejectThisTask: 'આ કાર્યને અસ્વીકાર કરો',
        editedProfileSuccefully: 'તમારી પ્રોફાઇલ સફળતાપૂર્વક અપડેટ કરી',
        enterAllFeilds: 'કૃપા કરીને બધી જરૂરી વિગતો દાખલ કરો',
        enterValidName: 'કૃપા કરી માન્ય નામ દાખલ કરો!',
        enterValidMobileNumber: 'કૃપા કરી તમારો માન્ય મોબાઇલ નંબર દાખલ કરો!',
        enterValidAddress: 'કૃપા કરી તમારું માન્ય સરનામું દાખલ કરો!',
        enterValidPinNumber: 'કૃપા કરી માન્ય પિનકોડ દાખલ કરો!',
        congrats: 'અભિનંદન',
        taskUploadedSuccessfully: 'તમારું કાર્ય સફળતાપૂર્વક અપલોડ થયું!',
        doYouReallyWantToAccept: 'શું તમે આ કાર્ય સ્વીકારવા માંગો છો?',
        doYouReallyWantToSumbit: 'શું તમે આ કાર્ય સબમિટ કરવા માંગો છો?',
        yes: 'હા',
        no: 'ના',
        later: 'પાછળથી',
        updateYourSkill: 'Please update your profile to continue',
        notUpdatedYourTask: 'Because of some reason did not complete your task, please try again.',
        toProceedPleaseUpdateProfile: "કૃપા કરીને કાર્ય સ્વીકૃતિ સાથે આગળ વધવા માટે પ્રોફાઇલ પર કુશળતા અપડેટ કરો",
        userNotAuthorized: 'user not authorized',
        alreadyAccepted: 'Already accepted',
        taskCompletionTime: 'કાર્ય પૂર્ણ થવા માટેનો સમય',
        goToProduct: 'કાર્ય પર જાઓ',
        getTask: 'કાર્ય મેળવો',
        paymentSuccessFull: 'ચુકવણી સફળ!',
        paymentUnSuccessFull: 'ચુકવણી નિષ્ફળ!',
        orderDetail: 'ઓર્ડર વિગત',
        name: 'પૂરું નામ',
        OrderId: 'ઓર્ડર Id',
        productName: 'ઉત્પાદન નામ',
        phoneNumber: 'મોબાઇલ નંબર',
        amount: 'રકમ',
        address: 'પૂરું સરનામું',
        pincode: 'પીન કોડ',
        city: 'શહેર',
        state: 'રાજ્ય',
        postOffice: 'ડાકઘર',
        makecall: 'કોલ કરો',
        callconnectMsg: 'Please wait while connecting call. Call will be initiated by this number {phoneNumber}.',
        orderAcceptedOrRejected: 'ગ્રાહકે આ ઓર્ડર સ્વીકાર્યો છે અથવા નકારી કા .્યો છે ?',
        orderAccepted: 'ઓર્ડર સ્વીકાર્યો',
        orderDenied: 'ઓર્ડર નામંજૂર',
        payRegisterationFees: 'નોંધણી ફી ચૂકવો',
        retry: 'Retry',
        orderStatus: 'ઓર્ડર સ્થિતિ',
        callCompletedOrRejected: 'Callર્ડર પર ક Callલ પૂર્ણ થયો છે કે નહીં ?',
        callCompleted: 'ક Callલ પૂર્ણ',
        callNotCompleted: 'ક Callલ પૂર્ણ થયો નથી',
        callNotPicked: 'ક Callલ કરેલ નથી',
        getNextTask: 'આગળનું કાર્ય મેળવો',
        noMoreRecord:'કોઈ વધુ રેકોર્ડ',
        getTaskAllowedMsg: 'આ કાર્ય 9am થી 8PM સુધી જ કરી શકાય છે',
        paymentMode: 'ચુકવણી મોડ',
        newTaskWillBeAvailable: 'નવા કાર્ય કેટલાક સમયમાં ઉપલબ્ધ થશે.',
        appBalanceChecked: 'એપ્લિકેશન બેલેન્સ તપાસ્યું',
        appBalanceNotChecked: 'એપ્લિકેશન બેલેન્સ તપાસ્યું નથી',
        walletBalance: 'વletલેટ બેલેન્સ',
        mPointBalance: 'MPoints બેલેન્સ',
        userDetail: 'વપરાશકર્તા વિગતો',
        notAvailable: 'ઉપલબ્ધ નથી',
        gameDownload: 'ડાઉનલોડ કરશે',
        gameNotDownload: 'ડાઉનલોડ કરશે નહીં',
        choosePaymentOption: 'Choose payment option',
        fillRegistrationForm: 'Fill Registration form',
        registered: 'Registered',
        mall91AgentWillCallYou: 'Congratulations!! We have received your details. Mall91 Agent would contact you soon!',
        supportedPincode: 'Supported Pincode'
    },

    kn: {
        partTime: 'ಅರೆಕಾಲಿಕ 91',
        allTasks: 'ಎಲ್ಲಾ ಕಾರ್ಯಗಳು',
        myTasks: 'ನನ್ನ ಕಾರ್ಯಗಳು',
        taskAvailable: 'ಕಾರ್ಯಗಳು ಲಭ್ಯವಿದೆ',
        taskAvailable: 'ಕಾರ್ಯ ಲಭ್ಯವಿದೆ',
        perTask: 'ಪ್ರತಿ ಕಾರ್ಯಕ್ಕೆ',
        leaderShipBoard: 'ನಾಯಕತ್ವ ಮಂಡಳಿ',
        viewetail: 'ವಿವರಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
        pendingTasks: 'ಕಾರ್ಯಗಳು ಬಾಕಿ ಉಳಿದಿವೆ',
        task: 'ಕಾರ್ಯ',
        completed: 'ಪೂರ್ಣಗೊಂಡಿದೆ',
        status: 'ಸ್ಥಿತಿ',
        payment: 'ಪಾವತಿ',
        seeSubmission: 'ಸಲ್ಲಿಕೆ ನೋಡಿ',
        contentReviewer: 'ವಿಷಯ ವಿಮರ್ಶಕ',
        leaderBoard: 'ಲೀಡರ್ಬೋರ್ಡ್',
        totalEarning: '',
        taskCompleted: 'ಕಾರ್ಯ ಪೂರ್ಣಗೊಂಡಿದೆ',
        profile: 'ಪ್ರೊಫೈಲ್',
        inWallet: 'ವಾಲೆಟ್ನಲ್ಲಿ',
        fullName: 'ಪೂರ್ಣ ಹೆಸರು',
        mobileNumber: 'ಮೊಬೈಲ್ ನಂಬರ',
        gender: 'ಲಿಂಗ',
        male: 'ಪುರುಷ',
        female: 'ಹೆಣ್ಣು',
        tellAboutYouself: 'ನಿಮ್ಮ ಬಗ್ಗೆ ಬರೆಯಿರಿ',
        writeHere: 'ಇಲ್ಲಿ ಬರೆಯಿರಿ...',
        address: 'ವಿಳಾಸ',
        skills: 'ಕೌಶಲ್ಯಗಳು',
        updateYourProfile: 'ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಅನ್ನು ನವೀಕರಿಸಿ',
        submitYourTask: 'ನಿಮ್ಮ ಕಾರ್ಯವನ್ನು ಸಲ್ಲಿಸಿ',
        addATitle: 'ಶೀರ್ಷಿಕೆಯನ್ನು ಸೇರಿಸಿ',
        writeTaskTitle: 'ಕಾರ್ಯ ಶೀರ್ಷಿಕೆಯನ್ನು ಬರೆಯಿರಿ',
        comments: '',
        optional: '',
        uploadAPhotoOrVideo: 'ಫೈಲ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ',
        supportFormat: 'ಬೆಂಬಲ ಸ್ವರೂಪ:',
        taskDetail: 'ಕಾರ್ಯ ವಿವರಗಳು',
        earning: 'ಗಳಿಕೆ',
        perTaskCompleted: 'ಪ್ರತಿ ಕಾರ್ಯ ಪೂರ್ಣಗೊಂಡಿದೆ',
        totalMoneyEarned: '',
        totalAvailableTask: 'ಒಟ್ಟು ಲಭ್ಯವಿರುವ ಕಾರ್ಯಗಳು',
        totalCompletedTask: 'ಒಟ್ಟು ಪೂರ್ಣಗೊಂಡ ಕಾರ್ಯಗಳು',
        howToCompleteTasks: 'ನಿಮ್ಮ ಕೆಲಸವನ್ನು ಹೇಗೆ ಪೂರ್ಣಗೊಳಿಸುವುದು',
        seeInvideo: 'ವೀಡಿಯೊದಲ್ಲಿ ನೋಡಿ',
        acceptThisTask: 'ಈ ಕಾರ್ಯವನ್ನು ಸ್ವೀಕರಿಸಿ',
        rejectThisTask: 'ಈ ಕಾರ್ಯವನ್ನು ತಿರಸ್ಕರಿಸಿ',
        editedProfileSuccefully: 'ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಅನ್ನು ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ',
        enterAllFeilds: 'ದಯವಿಟ್ಟು ಅಗತ್ಯವಿರುವ ಎಲ್ಲಾ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ',
        enterValidName: 'ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಹೆಸರನ್ನು ನಮೂದಿಸಿ!',
        enterValidMobileNumber: 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಮಾನ್ಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ!',
        enterValidAddress: 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಮಾನ್ಯ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ!',
        enterValidPinNumber: 'ದಯವಿಟ್ಟು ಮಾನ್ಯ ಪಿನ್ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ!',
        congrats: 'ಅಭಿನಂದನೆಗಳು',
        taskUploadedSuccessfully: 'ನಿಮ್ಮ ಕಾರ್ಯವನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಲಾಗಿದೆ!',
        doYouReallyWantToAccept: 'ಈ ಕಾರ್ಯವನ್ನು ಸ್ವೀಕರಿಸಲು ನೀವು ಬಯಸುವಿರಾ?',
        doYouReallyWantToSumbit: 'ಈ ಕಾರ್ಯವನ್ನು ಸಲ್ಲಿಸಲು ನೀವು ಬಯಸುವಿರಾ?',
        yes: 'ಹೌದು',
        no: 'ಇಲ್ಲ',
        later: 'ನಂತರ',
        updateYourSkill: 'Please update your profile to continue',
        notUpdatedYourTask: 'Because of some reason did not complete your task, please try again.',
        toProceedPleaseUpdateProfile: "ಕಾರ್ಯ ಸ್ವೀಕಾರದೊಂದಿಗೆ ಮುಂದುವರಿಯಲು ದಯವಿಟ್ಟು ಪ್ರೊಫೈಲ್‌ನಲ್ಲಿ ಕೌಶಲ್ಯಗಳನ್ನು ನವೀಕರಿಸಿ",
        userNotAuthorized: 'user not authorized',
        alreadyAccepted: 'Already accepted',
        taskCompletionTime: 'ಕಾರ್ಯ ಪೂರ್ಣಗೊಳಿಸುವ ಸಮಯ',
        goToProduct: 'ಕಾರ್ಯಕ್ಕೆ ಹೋಗಿ',
        getTask: 'ಕಾರ್ಯ ಪಡೆಯಿರಿ',
        paymentSuccessFull: 'ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ !',
        paymentUnSuccessFull: 'ಪಾವತಿ ವಿಫಲವಾಗಿದೆ!',
        orderDetail: 'ಆದೇಶ ವಿವರ',
        name: 'ಪೂರ್ಣ ಹೆಸರು',
        OrderId: 'ಆದೇಶ Id',
        productName: 'ಉತ್ಪನ್ನದ ಹೆಸರು',
        phoneNumber: 'ಮೊಬೈಲ್ ನಂಬರ',
        amount: 'ಮೊತ್ತ',
        address: 'ಪೂರ್ತಿ ವಿಳಾಸ ',
        pincode: 'ಪಿನ್ಕೋಡ್',
        city: 'ನಗರ',
        state: 'ರಾಜ್ಯ',
        postOffice: 'ಅಂಚೆ ಕಛೇರಿ',
        makecall: 'ಕರೆ ಮಾಡಿ',
        callconnectMsg: 'Please wait while connecting call. Call will be initiated by this number {phoneNumber}.',
        orderAcceptedOrRejected: 'ಗ್ರಾಹಕರು ಈ ಆದೇಶವನ್ನು ಸ್ವೀಕರಿಸಿದ್ದಾರೆ ಅಥವಾ ತಿರಸ್ಕರಿಸಿದ್ದಾರೆ?',
        orderAccepted: 'ಆದೇಶವನ್ನು ಸ್ವೀಕರಿಸಲಾಗಿದೆ',
        orderDenied: 'ಆದೇಶ ನಿರಾಕರಿಸಲಾಗಿದೆ',
        payRegisterationFees: 'ನೋಂದಣಿ ಶುಲ್ಕವನ್ನು ಪಾವತಿಸಿ',
        retry: 'Retry',
        orderStatus: 'ಆದೇಶ ಸ್ಥಿತಿ',
        callCompletedOrRejected: 'ಕರೆ ಆನ್ ಆರ್ಡರ್ ಪೂರ್ಣಗೊಂಡಿದೆ ಅಥವಾ ಇಲ್ಲ?',
        callCompleted: 'ಕರೆ ಪೂರ್ಣಗೊಂಡಿದೆ',
        callNotCompleted: 'ಕರೆ ಪೂರ್ಣಗೊಂಡಿಲ್ಲ',
        callNotPicked: 'ಕರೆ ಮಾಡಲಾಗಿಲ್ಲ',
        getNextTask: 'ಮುಂದಿನ ಕಾರ್ಯವನ್ನು ಪಡೆಯಿರಿ',
        noMoreRecord: 'ಹೆಚ್ಚಿನ ದಾಖಲೆಗಳಿಲ್ಲ',
        getTaskAllowedMsg: 'ಈ ಕಾರ್ಯವನ್ನು ಬೆಳಿಗ್ಗೆ 9 ರಿಂದ ರಾತ್ರಿ 8 ಗಂಟೆಯವರೆಗೆ ಮಾತ್ರ ನಿರ್ವಹಿಸಬಹುದು',
        paymentMode: 'ಪಾವತಿ ಮೋಡ್',
        newTaskWillBeAvailable: 'ಹೊಸ ಕಾರ್ಯವು ಕೆಲವು ಸಮಯದಲ್ಲಿ ಲಭ್ಯವಿರುತ್ತದೆ.',
        appBalanceChecked: 'ಅಪ್ಲಿಕೇಶನ್ ಬ್ಯಾಲೆನ್ಸ್ ಪರಿಶೀಲಿಸಲಾಗಿದೆ',
        appBalanceNotChecked: 'ಅಪ್ಲಿಕೇಶನ್ ಬಾಕಿ ಪರಿಶೀಲಿಸಲಾಗಿಲ್ಲ',
        walletBalance: 'ವಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್',
        mPointBalance: 'MPoints ಸಮತೋಲನ',
        userDetail: 'ಬಳಕೆದಾರರ ವಿವರ',
        notAvailable: 'ಲಭ್ಯವಿಲ್ಲ',
        gameDownload: 'ಡೌನ್‌ಲೋಡ್ ಮಾಡುತ್ತದೆ',
        gameNotDownload: 'ಡೌನ್‌ಲೋಡ್ ಮಾಡುವುದಿಲ್ಲ',
        choosePaymentOption: 'Choose payment option',
        fillRegistrationForm: 'Fill Registration form',
        registered: 'Registered',
        mall91AgentWillCallYou: 'Congratulations!! We have received your details. Mall91 Agent would contact you soon!',
        supportedPincode: 'Supported Pincode'

    },
    ml: {
        partTime: 'പാർട്ട് ടൈം 91',
        allTasks: 'എല്ലാ ജോലികളും',
        myTasks: 'എന്റെ ചുമതലകൾ',
        taskAvailable: 'ചുമതലകൾ ലഭ്യമാണ്',
        taskAvailable: 'ടാസ്ക് ലഭ്യമാണ്',
        perTask: 'ഓരോ ടാസ്‌ക്കിനും',
        leaderShipBoard: 'ലീഡർഷിപ്പ് ബോർഡ്',
        viewetail: 'വിശദാംശങ്ങൾ കാണുക',
        pendingTasks: 'ചുമതലകൾ തീർപ്പുകൽപ്പിച്ചിട്ടില്ല',
        task: 'ചുമതല',
        completed: 'പൂർത്തിയായി',
        status: 'പദവി',
        payment: 'പേയ്മെന്റ്',
        seeSubmission: 'സമർപ്പിക്കൽ കാണുക',
        contentReviewer: 'ഉള്ളടക്ക അവലോകകൻ',
        leaderBoard: 'ലീഡർബോർഡ്',
        totalEarning: '',
        taskCompleted: 'ടാസ്ക് പൂർത്തിയായി',
        profile: 'പ്രൊഫൈൽ',
        inWallet: 'വാലറ്റിൽ',
        fullName: 'പൂർണ്ണമായ പേര്',
        mobileNumber: 'ಮೊಬೈಲ್ ನಂಬರ',
        gender: 'ലിംഗഭേദം',
        male: 'ആൺ',
        female: 'പെൺ',
        tellAboutYouself: 'നിങ്ങളെ കുറിച്ച് എഴുതുക',
        writeHere: 'ഇവിടെ എഴുതുക...',
        address: 'വിലാസം',
        skills: 'കഴിവുകൾ',
        updateYourProfile: 'നിങ്ങളുടെ പ്രൊഫൈൽ അപ്‌ഡേറ്റുചെയ്യുക',
        submitYourTask: 'നിങ്ങളുടെ ടാസ്ക് സമർപ്പിക്കുക',
        addATitle: 'ഒരു ശീർഷകം ചേർക്കുക',
        writeTaskTitle: 'ടാസ്‌ക് ശീർഷകം എഴുതുക',
        comments: '',
        optional: '',
        uploadAPhotoOrVideo: 'ഫയൽ അപ്‌ലോഡുചെയ്യുക',
        supportFormat: 'പിന്തുണാ ഫോർമാറ്റ്:',
        taskDetail: 'ടാസ്‌ക് വിശദാംശങ്ങൾ',
        earning: 'സമ്പാദിച്ച',
        perTaskCompleted: 'ഓരോ ജോലിയും പൂർത്തിയായി',
        totalMoneyEarned: '',
        totalAvailableTask: 'ലഭ്യമായ ആകെ ജോലികൾ',
        totalCompletedTask: 'ആകെ പൂർത്തിയാക്കിയ ജോലികൾ',
        howToCompleteTasks: 'നിങ്ങളുടെ ചുമതല എങ്ങനെ പൂർത്തിയാക്കാം',
        seeInvideo: 'വീഡിയോയിൽ കാണുക',
        acceptThisTask: 'ഈ ടാസ്ക് സ്വീകരിക്കുക',
        rejectThisTask: 'ഈ ടാസ്ക് നിരസിക്കുക',
        editedProfileSuccefully: 'നിങ്ങളുടെ പ്രൊഫൈൽ വിജയകരമായി അപ്‌ഡേറ്റുചെയ്‌തു',
        enterAllFeilds: 'ആവശ്യമായ എല്ലാ വിശദാംശങ്ങളും നൽകുക',
        enterValidName: 'സാധുവായ പേര് നൽകുക!',
        enterValidMobileNumber: 'നിങ്ങളുടെ സാധുവായ മൊബൈൽ നമ്പർ നൽകുക!',
        enterValidAddress: 'നിങ്ങളുടെ സാധുവായ വിലാസം നൽകുക!',
        enterValidPinNumber: 'സാധുവായ പിൻകോഡ് നൽകുക!',
        congrats: 'അഭിനന്ദനങ്ങൾ',
        taskUploadedSuccessfully: 'നിങ്ങളുടെ ടാസ്‌ക് വിജയകരമായി അപ്‌ലോഡുചെയ്‌തു!',
        doYouReallyWantToAccept: 'ഈ ചുമതല സ്വീകരിക്കാൻ നിങ്ങൾ ആഗ്രഹിക്കുന്നുണ്ടോ?',
        doYouReallyWantToSumbit: 'ഈ ടാസ്ക് സമർപ്പിക്കാൻ നിങ്ങൾ ആഗ്രഹിക്കുന്നുണ്ടോ?',
        yes: 'അതെ',
        no: 'ഇല്ല',
        later: 'പിന്നീട്',
        updateYourSkill: 'Please update your profile to continue',
        notUpdatedYourTask: 'Because of some reason did not complete your task, please try again.',
        toProceedPleaseUpdateProfile: "ടാസ്‌ക് സ്വീകാര്യത തുടരുന്നതിന് പ്രൊഫൈലിൽ കഴിവുകൾ അപ്‌ഡേറ്റുചെയ്യുക",
        userNotAuthorized: 'user not authorized',
        alreadyAccepted: 'Already accepted',
        taskCompletionTime: 'ടാസ്ക് പൂർ‌ത്തിയാക്കുന്ന സമയം',
        goToProduct: 'ചുമതലയിലേക്ക് പോകുക',
        getTask: 'ടാസ്ക് നേടുക',
        paymentSuccessFull: 'പേയ്‌മെന്റ് വിജയകരം !',
        paymentUnSuccessFull: 'പേയ്‌മെന്റ് പരാജയപ്പെട്ടു!',
        orderDetail: 'ഓർഡർ വിശദാംശങ്ങൾ',
        name: 'മുഴുവൻ പേര്',
        OrderId: 'ഓർഡർ Id',
        productName: 'ഉത്പന്നത്തിന്റെ പേര്',
        phoneNumber: 'മൊബൈൽ നമ്പർ',
        amount: 'തുക',
        address: 'മുഴുവൻ വിലാസം',
        pincode: 'പിൻ കോഡ്',
        city: 'നഗരം',
        state: 'സംസ്ഥാനം',
        postOffice: 'പോസ്റ്റ് ഓഫീസ്',
        makecall: 'വിളിക്കുക',
        callconnectMsg: 'Please wait while connecting call. Call will be initiated by this number {phoneNumber}.',
        orderAcceptedOrRejected: 'ഉപഭോക്താവ് ഈ ഓർഡർ സ്വീകരിക്കുകയോ നിരസിക്കുകയോ ചെയ്തു?',
        orderAccepted: 'ഓർഡർ സ്വീകരിച്ചു',
        orderDenied: 'ഓർഡർ നിരസിച്ചു',
        payRegisterationFees: 'രജിസ്ട്രേഷൻ ഫീസ് അടയ്ക്കുക',
        retry: 'Retry',
        orderStatus: 'ഓർഡർ നില',
        callCompletedOrRejected: 'കോൾ ഓൺ ഓർഡർ പൂർത്തിയായി അല്ലെങ്കിൽ ഇല്ല?',
        callCompleted: 'കോൾ പൂർത്തിയായി',
        callNotCompleted: 'കോൾ പൂർത്തിയായിട്ടില്ല',
        callNotPicked: 'കോൾ എടുത്തില്ല',
        getNextTask: 'അടുത്ത ചുമതല നേടുക',
        noMoreRecord: 'കൂടുതൽ റെക്കോർഡുകളൊന്നുമില്ല',
        getTaskAllowedMsg: 'രാവിലെ 9 മുതൽ രാത്രി 8 വരെ മാത്രമേ ഈ ചുമതല നിർവഹിക്കാൻ കഴിയൂ',
        paymentMode: 'പേയ്‌മെന്റ് മോഡ്',
        newTaskWillBeAvailable: 'പുതിയ ടാസ്‌ക് കുറച്ച് സമയത്തിനുള്ളിൽ ലഭ്യമാകും.',
        appBalanceChecked: 'അപ്ലിക്കേഷൻ ബാലൻസ് പരിശോധിച്ചു',
        appBalanceNotChecked: 'അപ്ലിക്കേഷൻ ബാലൻസ് പരിശോധിച്ചിട്ടില്ല',
        walletBalance: 'വാലറ്റ് ബാലൻസ്',
        mPointBalance: 'MPoints ബാലൻസ്',
        userDetail: 'ഉപയോക്തൃ വിശദാംശം',
        notAvailable: 'ലഭ്യമല്ല',
        gameDownload: 'ഡൗൺലോഡുചെയ്യും',
        gameNotDownload: 'ഡ .ൺലോഡ് ചെയ്യില്ല',
        choosePaymentOption: 'Choose payment option',
        fillRegistrationForm: 'Fill Registration form',
        registered: 'Registered',
        mall91AgentWillCallYou: 'Congratulations!! We have received your details. Mall91 Agent would contact you soon!',
        supportedPincode: 'Supported Pincode'
    },
    mr: {
        partTime: 'भाग वेळ 91',
        allTasks: 'सर्व कार्ये',
        myTasks: 'माझी कार्ये',
        taskAvailable: 'कार्ये उपलब्ध',
        taskAvailable: 'कार्य उपलब्ध',
        perTask: 'प्रति कार्य',
        leaderShipBoard: 'नेतृत्व मंडळ',
        viewetail: 'तपशील पहा',
        pendingTasks: 'प्रलंबित कामे',
        task: 'कार्य',
        completed: 'पूर्ण झाले',
        status: 'स्थिती',
        payment: 'देय',
        seeSubmission: 'सबमिशन पहा',
        contentReviewer: 'सामग्री पुनरावलोकनकर्ता',
        leaderBoard: 'लीडरबोर्ड',
        totalEarning: '',
        taskCompleted: 'कार्य पूर्ण झाले',
        profile: 'प्रोफाइल',
        inWallet: 'वॉलेट मध्ये',
        fullName: 'पूर्ण नाव',
        mobileNumber: 'मोबाइल नंबर',
        gender: 'लिंग',
        male: 'मेल',
        female: 'स्त्री',
        tellAboutYouself: 'तुमच्याविषयी लिहा',
        writeHere: 'येथे लिहा ...',
        address: 'पत्ता',
        skills: 'कौशल्य',
        updateYourProfile: 'आपले प्रोफाइल अद्यतनित करा',
        submitYourTask: 'आपले कार्य सबमिट करा',
        addATitle: 'एक शीर्षक जोडा',
        writeTaskTitle: 'टास्क टायटल लिहा',
        comments: '',
        optional: '',
        uploadAPhotoOrVideo: 'फाइल अपलोड करा',
        supportFormat: 'समर्थन स्वरूप:',
        taskDetail: 'कार्य तपशील',
        earning: 'कमाई',
        perTaskCompleted: 'प्रति कार्य पूर्ण',
        totalMoneyEarned: '',
        totalAvailableTask: 'एकूण उपलब्ध कार्ये',
        totalCompletedTask: 'एकूण पूर्ण कामे',
        howToCompleteTasks: 'आपले कार्य कसे पूर्ण करावे',
        seeInvideo: 'व्हिडिओमध्ये पहा',
        acceptThisTask: 'हे कार्य स्वीकारा',
        rejectThisTask: 'हे कार्य नाकारा',
        editedProfileSuccefully: 'आपले प्रोफाइल यशस्वीरित्या अद्यतनित केले',
        enterAllFeilds: 'कृपया सर्व आवश्यक तपशील प्रविष्ट करा',
        enterValidName: 'कृपया वैध नाव प्रविष्ट करा!',
        enterValidMobileNumber: 'कृपया आपला वैध मोबाइल नंबर प्रविष्ट करा!',
        enterValidAddress: 'कृपया आपला वैध पत्ता प्रविष्ट करा!',
        enterValidPinNumber: 'कृपया वैध पिनकोड प्रविष्ट करा!',
        congrats: 'अभिनंदन',
        taskUploadedSuccessfully: 'आपले कार्य यशस्वीरित्या अपलोड झाले!',
        doYouReallyWantToAccept: 'आपण हे कार्य स्वीकारू इच्छिता?',
        doYouReallyWantToSumbit: 'आपण हे कार्य सबमिट करू इच्छिता?',
        yes: 'होय',
        no: 'ਨਹੀਂ',
        later: 'नंतर',
        updateYourSkill: 'Please update your profile to continue',
        notUpdatedYourTask: 'Because of some reason did not complete your task, please try again.',
        toProceedPleaseUpdateProfile: "कृपया कार्य स्वीकृतीसह पुढे जाण्यासाठी प्रोफाइलवरील कौशल्ये अद्यतनित करा",
        userNotAuthorized: 'user not authorized',
        alreadyAccepted: 'Already accepted',
        taskCompletionTime: 'कार्य पूर्ण होण्याची वेळ',
        goToProduct: 'टास्क वर जा',
        getTask: 'टास्क मिळवा',
        paymentSuccessFull: 'देय यशस्वी !',
        paymentUnSuccessFull: 'देय देणे अयशस्वी!',
        orderDetail: 'ऑर्डर तपशील',
        name: 'पूर्ण नाव',
        OrderId: 'ऑर्डर Id',
        productName: 'उत्पादनाचे नांव',
        phoneNumber: 'मोबाइल नंबर',
        amount: 'रक्कम',
        address: 'संपूर्ण पत्ता',
        pincode: 'पिन कोड',
        city: 'शहर',
        state: 'राज्य',
        postOffice: 'टपाल कार्यालय',
        makecall: 'कॉल करा',
        callconnectMsg: 'Please wait while connecting call. Call will be initiated by this number {phoneNumber}.',
        orderAcceptedOrRejected: 'ग्राहकांनी ही ऑर्डर स्वीकारली किंवा नाकारली आहे ?',
        orderAccepted: 'ऑर्डर स्वीकारली',
        orderDenied: 'ऑर्डर नाकारली',
        payRegisterationFees: 'नोंदणी शुल्क भरा',
        retry: 'Retry',
        orderStatus: 'आदेश स्थिती',
        callCompletedOrRejected: 'कॉल ऑन ऑर्डर पूर्ण झाले की नाही?',
        callCompleted: 'कॉल पूर्ण झाला',
        callNotCompleted: 'कॉल पूर्ण झाला नाही',
        callNotPicked: 'कॉल केलेला नाही',
        getNextTask: 'पुढील कार्य मिळवा',
        noMoreRecord:'आणखी रेकॉर्ड नाही',
        getTaskAllowedMsg: 'हे कार्य 9am पासून केवळ 8PM पर्यंत केले जाऊ शकते',
        paymentMode: 'देय मोड',
        newTaskWillBeAvailable: 'नवीन कार्य काही वेळात उपलब्ध होईल.',
        appBalanceChecked: 'अ‍ॅप शिल्लक तपासले',
        appBalanceNotChecked: 'अ‍ॅप शिल्लक तपासले गेले नाही',
        walletBalance: 'वॉलेट बॅलन्स',
        mPointBalance: 'MPoints शिल्लक',
        userDetail: 'वापरकर्ता तपशील',
        notAvailable: 'उपलब्ध नाही',
        gameDownload: 'डाउनलोड करेल',
        gameNotDownload: 'डाउनलोड करणार नाही',
        choosePaymentOption: 'Choose payment option',
        fillRegistrationForm: 'Fill Registration form',
        registered: 'Registered',
        mall91AgentWillCallYou: 'Congratulations!! We have received your details. Mall91 Agent would contact you soon!',
        supportedPincode: 'Supported Pincode'
    },
    pa: {
        partTime: 'ਪਾਰਟ ਟਾਈਮ 91',
        allTasks: 'ਸਾਰੇ ਕੰਮ',
        myTasks: 'ਮੇਰੇ ਕੰਮ',
        taskAvailable: 'ਕੰਮ ਉਪਲਬਧ ਹਨ',
        taskAvailable: 'ਕੰਮ ਉਪਲੱਬਧ',
        perTask: 'ਪ੍ਰਤੀ ਕੰਮ',
        leaderShipBoard: 'ਲੀਡਰਸ਼ਿਪ ਬੋਰਡ',
        viewetail: 'ਵੇਰਵਾ ਵੇਖੋ',
        pendingTasks: 'ਕੰਮ ਬਕਾਇਆ',
        task: 'ਕੰਮ',
        completed: 'ਮੁਕੰਮਲ',
        status: 'ਸਥਿਤੀ',
        payment: 'ਭੁਗਤਾਨ',
        seeSubmission: 'ਅਧੀਨਗੀ ਵੇਖੋ',
        contentReviewer: 'ਸਮਗਰੀ ਸਮੀਖਿਅਕ',
        leaderBoard: 'ਲੀਡਰਬੋਰਡ',
        totalEarning: '',
        taskCompleted: 'ਕਾਰਜ ਪੂਰਾ ਹੋਇਆ',
        profile: 'ਪ੍ਰੋਫਾਈਲ',
        inWallet: 'ਵਾਲਿਟ ਵਿਚ',
        fullName: 'ਪੂਰਾ ਨਾਂਮ',
        mobileNumber: 'ਮੋਬਾਈਲ ਨੰਬਰ',
        gender: 'ਲਿੰਗ',
        male: 'ਨਰ',
        female: 'Femaleਰਤ',
        tellAboutYouself: 'ਆਪਣੇ ਆਪ ਬਾਰੇ ਲਿਖੋ',
        writeHere: 'ਇੱਥੇ ਲਿਖੋ ...',
        address: 'ਪਤਾ',
        skills: 'ਹੁਨਰ',
        updateYourProfile: 'ਆਪਣੀ ਪ੍ਰੋਫਾਈਲ ਨੂੰ ਅਪਡੇਟ ਕਰੋ',
        submitYourTask: 'ਆਪਣਾ ਕੰਮ ਜਮ੍ਹਾਂ ਕਰੋ',
        addATitle: 'ਇੱਕ ਸਿਰਲੇਖ ਸ਼ਾਮਲ ਕਰੋ',
        writeTaskTitle: 'ਕਾਰਜ ਦਾ ਸਿਰਲੇਖ ਲਿਖੋ',
        comments: '',
        optional: '',
        uploadAPhotoOrVideo: 'ਫਾਈਲ ਅਪਲੋਡ ਕਰੋ',
        supportFormat: 'ਸਹਾਇਤਾ ਫਾਰਮੈਟ:',
        taskDetail: 'ਕਾਰਜ ਵੇਰਵਾ',
        earning: 'ਕਮਾਈ',
        perTaskCompleted: 'ਪ੍ਰਤੀ ਕੰਮ ਪੂਰਾ ਹੋਇਆ',
        totalMoneyEarned: '',
        totalAvailableTask: 'ਕੁੱਲ ਉਪਲਬਧ ਕਾਰਜ',
        totalCompletedTask: 'ਕੁੱਲ ਮੁਕੰਮਲ ਕੀਤੇ ਕਾਰਜ',
        howToCompleteTasks: 'ਆਪਣੇ ਕੰਮ ਨੂੰ ਕਿਵੇਂ ਪੂਰਾ ਕਰਨਾ ਹੈ',
        seeInvideo: 'ਵੀਡੀਓ ਵਿਚ ਦੇਖੋ',
        acceptThisTask: 'ਇਸ ਕਾਰਜ ਨੂੰ ਸਵੀਕਾਰ ਕਰੋ',
        rejectThisTask: 'ਇਸ ਕਾਰਜ ਨੂੰ ਅਸਵੀਕਾਰ ਕਰੋ',
        editedProfileSuccefully: 'ਤੁਹਾਡੀ ਪ੍ਰੋਫਾਈਲ ਨੂੰ ਸਫਲਤਾਪੂਰਵਕ ਅਪਡੇਟ ਕੀਤਾ',
        enterAllFeilds: 'ਕਿਰਪਾ ਕਰਕੇ ਸਾਰੇ ਲੋੜੀਂਦੇ ਵੇਰਵੇ ਦਰਜ ਕਰੋ',
        enterValidName: 'ਕਿਰਪਾ ਕਰਕੇ ਯੋਗ ਨਾਮ ਦਾਖਲ ਕਰੋ!',
        enterValidMobileNumber: 'ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਵੈਧ ਮੋਬਾਈਲ ਨੰਬਰ ਦਾਖਲ ਕਰੋ!',
        enterValidAddress: 'ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਜਾਇਜ਼ ਪਤਾ ਦਾਖਲ ਕਰੋ!',
        enterValidPinNumber: 'ਕਿਰਪਾ ਕਰਕੇ ਵੈਧ ਪਨਕੋਡ ਦਰਜ ਕਰੋ!',
        congrats: 'ਵਧਾਈ',
        taskUploadedSuccessfully: 'ਤੁਹਾਡਾ ਕੰਮ ਸਫਲਤਾਪੂਰਵਕ ਅਪਲੋਡ ਹੋਇਆ!',
        doYouReallyWantToAccept: 'ਕੀ ਤੁਸੀਂ ਇਸ ਕਾਰਜ ਨੂੰ ਸਵੀਕਾਰ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?',
        doYouReallyWantToSumbit: 'ਕੀ ਤੁਸੀਂ ਇਸ ਕਾਰਜ ਨੂੰ ਜਮ੍ਹਾ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?',
        yes: 'ਹਾਂ',
        no: 'ਨਹੀਂ',
        later: 'ਬਾਅਦ ਵਿਚ',
        updateYourSkill: 'Please update your profile to continue',
        notUpdatedYourTask: 'Because of some reason did not complete your task, please try again.',
        toProceedPleaseUpdateProfile: "ਕਿਰਪਾ ਕਰਕੇ ਕਾਰਜ ਸਵੀਕਾਰਨ ਲਈ ਅੱਗੇ ਜਾਣ ਲਈ ਪ੍ਰੋਫਾਈਲ 'ਤੇ ਕੁਸ਼ਲਤਾਵਾਂ ਨੂੰ ਅਪਡੇਟ ਕਰੋ",
        userNotAuthorized: 'user not authorized',
        alreadyAccepted: 'Already accepted',
        taskCompletionTime: 'ਕੰਮ ਪੂਰਾ ਹੋਣ ਦਾ ਸਮਾਂ',
        goToProduct: 'ਕੰਮ ਤੇ ਜਾਓ',
        getTask: 'ਟਾਸਕ ਲਵੋ',
        paymentSuccessFull: 'ਭੁਗਤਾਨ ਸਫਲ !',
        paymentUnSuccessFull: 'ਭੁਗਤਾਨ ਅਸਫਲ!',
        orderDetail: 'ਆਰਡਰ ਵੇਰਵਾ',
        name: 'ਪੂਰਾ ਨਾਮ',
        OrderId: 'ਆਰਡਰ Id',
        productName: 'ਉਤਪਾਦ ਦਾ ਨਾਮ',
        phoneNumber: 'ਮੋਬਾਈਲ ਨੰਬਰ',
        amount: 'ਦੀ ਰਕਮ',
        address: 'ਪੂਰਾ ਪਤਾ',
        pincode: 'ਪਿੰਨ ਕੋਡ',
        city: 'ਸ਼ਹਿਰ',
        state: 'ਰਾਜ',
        postOffice: 'ਡਾਕਖਾਨਾ',
        makecall: 'ਕਾਲ ਕਰੋ',
        callconnectMsg: 'Please wait while connecting call. Call will be initiated by this number {phoneNumber}.',
        orderAcceptedOrRejected: 'ਗਾਹਕ ਨੇ ਇਸ ਆਰਡਰ ਨੂੰ ਸਵੀਕਾਰ ਜਾਂ ਅਸਵੀਕਾਰ ਕਰ ਦਿੱਤਾ ਹੈ?',
        orderAccepted: 'ਆਰਡਰ ਸਵੀਕਾਰਿਆ ਗਿਆ',
        orderDenied: 'ਆਰਡਰ ਅਸਵੀਕਾਰ ਕੀਤਾ',
        payRegisterationFees: 'ਭੁਗਤਾਨ ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਫੀਸ',
        retry: 'Retry',
        orderStatus: 'ਆਰਡਰ ਸਥਿਤੀ',
        callCompletedOrRejected: 'ਕਾਲ ਆੱਰ ਆਰਡਰ ਪੂਰਾ ਹੋ ਗਿਆ ਹੈ ਜਾਂ ਨਹੀਂ?',
        callCompleted: 'ਕਾਲ ਪੂਰੀ',
        callNotCompleted: 'ਕਾਲ ਪੂਰੀ ਨਹੀਂ ਹੋਈ',
        callNotPicked: 'ਕਾਲ ਪਿਕ ਨਾ ਕੀਤੀ',
        getNextTask: 'ਅਗਲਾ ਕੰਮ ਪ੍ਰਾਪਤ ਕਰੋ',
        noMoreRecord:'ਕੋਈ ਹੋਰ ਰਿਕਾਰਡ',
        getTaskAllowedMsg: 'ਇਹ ਕੰਮ ਸਵੇਰੇ 9 ਵਜੇ ਤੋਂ ਸਵੇਰੇ 8 ਵਜੇ ਤੱਕ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ',
        paymentMode: 'ਭੁਗਤਾਨ ਵਿਧੀ',
        newTaskWillBeAvailable: 'ਨਵਾਂ ਕੰਮ ਕੁਝ ਸਮੇਂ ਵਿੱਚ ਉਪਲਬਧ ਹੋ ਜਾਵੇਗਾ.',
        appBalanceChecked: 'ਐਪ ਦਾ ਬਕਾਇਆ ਚੈੱਕ ਕੀਤਾ ਗਿਆ',
        appBalanceNotChecked: 'ਐਪ ਬੈਲੰਸ ਦੀ ਜਾਂਚ ਨਹੀਂ ਕੀਤੀ ਗਈ',
        walletBalance: 'ਵਾਲਿਟ ਬੈਲੰਸ',
        mPointBalance: 'MPoints ਸੰਤੁਲਨ',
        userDetail: 'ਉਪਭੋਗਤਾ ਦਾ ਵੇਰਵਾ',
        notAvailable: 'ਉਪਲਭਦ ਨਹੀ',
        gameDownload: 'ਡਾ Downloadਨਲੋਡ ਕਰੇਗਾ',
        gameNotDownload: 'ਡਾਉਨਲੋਡ ਨਹੀਂ ਕਰੇਗਾ',
        choosePaymentOption: 'Choose payment option',
        fillRegistrationForm: 'Fill Registration form',
        registered: 'Registered',
        mall91AgentWillCallYou: 'Congratulations!! We have received your details. Mall91 Agent would contact you soon!',
        supportedPincode: 'Supported Pincode'
    },
    ta: {
        partTime: 'பகுதி நேரம் 91',
        allTasks: 'அனைத்து பணிகள்',
        myTasks: 'எனது பணிகள்',
        taskAvailable: 'பணிகள் கிடைக்கின்றன',
        taskAvailable: 'பணி கிடைக்கிறது',
        perTask: 'ஒரு பணிக்கு',
        leaderShipBoard: 'தலைமை வாரியம்',
        viewetail: 'விபரங்களை பார்',
        pendingTasks: 'பணிகள் நிலுவையில் உள்ளன',
        task: 'பணி',
        completed: 'நிறைவு',
        status: 'நிலை',
        payment: 'கட்டணம்',
        seeSubmission: 'சமர்ப்பிப்பைக் காண்க',
        contentReviewer: 'உள்ளடக்க மதிப்பாய்வாளர்',
        leaderBoard: 'லீடர்போர்டு',
        totalEarning: '',
        taskCompleted: 'பணி முடிந்தது',
        profile: 'சுயவிவரம்',
        inWallet: 'Wallet இல்',
        fullName: 'முழு பெயர்',
        mobileNumber: 'கைபேசி எண்',
        gender: 'பாலினம்',
        male: 'ஆண்',
        female: 'பெண்',
        tellAboutYouself: 'உங்களை பற்றி எழுத',
        writeHere: 'இங்கே எழுது ...',
        address: 'முகவரி',
        skills: 'திறன்கள்',
        updateYourProfile: 'உங்கள் சுயவிவரத்தைப் புதுப்பிக்கவும்',
        submitYourTask: 'உங்கள் பணியைச் சமர்ப்பிக்கவும்',
        addATitle: 'ஒரு தலைப்பைச் சேர்க்கவும்',
        writeTaskTitle: 'பணி தலைப்பை எழுதுங்கள்',
        comments: '',
        optional: '',
        uploadAPhotoOrVideo: 'கோப்பை பதிவேற்றவும்',
        supportFormat: 'ஆதரவு வடிவம்:',
        taskDetail: 'பணி விவரங்கள்',
        earning: 'சம்பாதிப்பது',
        perTaskCompleted: 'ஒரு பணி முடிந்தது',
        totalMoneyEarned: '',
        totalAvailableTask: 'மொத்தம் கிடைக்கும் பணிகள்',
        totalCompletedTask: 'மொத்த பணிகள்',
        howToCompleteTasks: 'உங்கள் பணியை எவ்வாறு முடிப்பது',
        seeInvideo: 'வீடியோவில் காண்க',
        acceptThisTask: 'இந்த பணியை ஏற்றுக்கொள்ளுங்கள்',
        rejectThisTask: 'இந்த பணியை நிராகரிக்கவும்',
        editedProfileSuccefully: 'உங்கள் சுயவிவரத்தை வெற்றிகரமாக புதுப்பித்தது',
        enterAllFeilds: 'தேவையான அனைத்து விவரங்களையும் உள்ளிடவும்',
        enterValidName: 'சரியான பெயரை உள்ளிடவும்!',
        enterValidMobileNumber: 'உங்கள் செல்லுபடியாகும் மொபைல் எண்ணை உள்ளிடவும்!',
        enterValidAddress: 'உங்கள் சரியான முகவரியை உள்ளிடவும்!',
        enterValidPinNumber: 'செல்லுபடியாகும் பின்கோடை உள்ளிடவும்!',
        congrats: 'வாழ்த்துக்கள்',
        taskUploadedSuccessfully: 'உங்கள் பணி வெற்றிகரமாக பதிவேற்றப்பட்டது!',
        doYouReallyWantToAccept: 'இந்த பணியை ஏற்க விரும்புகிறீர்களா?',
        doYouReallyWantToSumbit: 'இந்த பணியை சமர்ப்பிக்க விரும்புகிறீர்களா?',
        yes: 'ஆம்',
        no: 'இல்லை',
        later: 'பின்னர்',
        updateYourSkill: 'Please update your profile to continue',
        notUpdatedYourTask: 'Because of some reason did not complete your task, please try again.',
        toProceedPleaseUpdateProfile: "பணி ஏற்றுக்கொள்ளலுடன் தொடர சுயவிவரத்தில் திறன்களைப் புதுப்பிக்கவும்",
        userNotAuthorized: 'user not authorized',
        alreadyAccepted: 'Already accepted',
        taskCompletionTime: 'பணி நிறைவு நேரம்',
        goToProduct: 'பணிக்குச் செல்லுங்கள்',
        getTask: 'பணி கிடைக்கும்',
        paymentSuccessFull: 'கட்டணம் வெற்றிகரமாக!',
        paymentUnSuccessFull: 'கட்டணம் தோல்வியடைந்தது!',
        orderDetail: 'ஆர்டர் விவரம்',
        name: 'முழு பெயர்',
        OrderId: 'ஆர்டர் Id',
        productName: 'பொருளின் பெயர்',
        phoneNumber: 'கைபேசி எண்',
        amount: 'தொகை',
        address: 'முழு முகவரி',
        pincode: 'அஞ்சல் குறியீடு',
        city: 'நகரம்',
        state: 'நிலை',
        postOffice: 'தபால் அலுவலகம்',
        makecall: 'அழைப்பு விடுங்கள்',
        callconnectMsg: 'Please wait while connecting call. Call will be initiated by this number {phoneNumber}.',
        orderAcceptedOrRejected: 'வாடிக்கையாளர் இந்த ஆர்டரை ஏற்றுக்கொண்டார் அல்லது நிராகரித்தார் ?',
        orderAccepted: 'ஆர்டர் ஏற்றுக்கொள்ளப்பட்டது',
        orderDenied: 'உத்தரவு மறுக்கப்பட்டது',
        payRegisterationFees: 'பதிவு கட்டணம் செலுத்தவும்',
        retry: 'Retry',
        orderStatus: 'ஆர்டர் நிலை',
        callCompletedOrRejected: 'அழைப்புக்கான ஆர்டர் முடிந்தது அல்லது இல்லை ?',
        callCompleted: 'அழைப்பு முடிந்தது',
        callNotCompleted: 'அழைப்பு முடிக்கப்படவில்லை',
        callNotPicked: 'அழைக்கப்படவில்லை',
        getNextTask: 'அடுத்த பணியைப் பெறுங்கள்',
        noMoreRecord:'மேலும் பதிவு இல்லை',
        getTaskAllowedMsg: 'இந்த பணியை காலை 9 மணி முதல் இரவு 8 மணி வரை மட்டுமே செய்ய முடியும்',
        paymentMode: 'கட்டண முறை',
        newTaskWillBeAvailable: 'புதிய பணி சில காலங்களில் கிடைக்கும்.',
        appBalanceChecked: 'பயன்பாட்டு இருப்பு சரிபார்க்கப்பட்டது',
        appBalanceNotChecked: 'பயன்பாட்டு இருப்பு சரிபார்க்கப்படவில்லை',
        walletBalance: 'Wallet இருப்பு',
        mPointBalance: 'MPoints இருப்பு',
        userDetail: 'பயனர் விவரம்',
        notAvailable: 'கிடைக்கவில்லை',
        gameDownload: 'பதிவிறக்கும்',
        gameNotDownload: 'பதிவிறக்காது',
        choosePaymentOption: 'Choose payment option',
        fillRegistrationForm: 'Fill Registration form',
        registered: 'Registered',
        mall91AgentWillCallYou: 'Congratulations!! We have received your details. Mall91 Agent would contact you soon!',
        supportedPincode: 'Supported Pincode'
    },
    te: {
        partTime: 'పార్ట్ టైమ్ 91',
        allTasks: 'అన్ని పనులు',
        myTasks: 'నా పనులు',
        taskAvailable: 'విధులు అందుబాటులో ఉన్నాయి',
        taskAvailable: 'టాస్క్ అందుబాటులో ఉంది',
        perTask: 'ప్రతి పనికి',
        leaderShipBoard: 'నాయకత్వ బోర్డు',
        viewetail: 'వివరాలను చూడండి',
        pendingTasks: 'విధులు పెండింగ్‌లో ఉన్నాయి',
        task: 'పని',
        completed: 'పూర్తయింది',
        status: 'స్థితి',
        payment: 'చెల్లింపు',
        seeSubmission: 'సమర్పణ చూడండి',
        contentReviewer: 'కంటెంట్ సమీక్షకుడు',
        leaderBoard: 'లీడర్బోర్డ్',
        totalEarning: '',
        taskCompleted: 'టాస్క్ పూర్తయింది',
        profile: 'ప్రొఫైల్',
        inWallet: 'Wallet లో',
        fullName: 'పూర్తి పేరు',
        mobileNumber: 'మొబైల్ సంఖ్య',
        gender: 'జెండర్',
        male: 'పురుషుడు',
        female: 'స్త్రీ',
        tellAboutYouself: 'మీ గురించి రాయండి',
        writeHere: 'ఇక్కడ వ్రాయండి...',
        address: 'చిరునామా',
        skills: 'నైపుణ్యాలు',
        updateYourProfile: 'మీ ప్రొఫైల్‌ను నవీకరించండి',
        submitYourTask: 'మీ టాస్క్ సమర్పించండి',
        addATitle: 'శీర్షికను జోడించండి',
        writeTaskTitle: 'టాస్క్ టైటిల్ రాయండి',
        comments: '',
        optional: '',
        uploadAPhotoOrVideo: 'ఫైల్‌ను అప్‌లోడ్ చేయండి',
        supportFormat: 'మద్దతు ఆకృతి:',
        taskDetail: 'టాస్క్ వివరాలు',
        earning: 'ఎర్నింగ్',
        perTaskCompleted: 'ప్రతి పని పూర్తయింది',
        totalMoneyEarned: '',
        totalAvailableTask: 'మొత్తం అందుబాటులో ఉన్న పనులు',
        totalCompletedTask: 'మొత్తం పూర్తయిన పనులు',
        howToCompleteTasks: 'మీ పనిని ఎలా పూర్తి చేయాలి',
        seeInvideo: 'వీడియోలో చూడండి',
        acceptThisTask: 'ఈ టాస్క్‌ను అంగీకరించండి',
        rejectThisTask: 'ఈ టాస్క్‌ను తిరస్కరించండి',
        editedProfileSuccefully: 'మీ ప్రొఫైల్ విజయవంతంగా నవీకరించబడింది',
        enterAllFeilds: 'దయచేసి అవసరమైన అన్ని వివరాలను నమోదు చేయండి',
        enterValidName: 'దయచేసి చెల్లుబాటు అయ్యే పేరును నమోదు చేయండి!',
        enterValidMobileNumber: 'దయచేసి మీ చెల్లుబాటు అయ్యే మొబైల్ నంబర్‌ను నమోదు చేయండి!',
        enterValidAddress: 'దయచేసి మీ చెల్లుబాటు అయ్యే చిరునామాను నమోదు చేయండి!',
        enterValidPinNumber: 'దయచేసి చెల్లుబాటు అయ్యే పిన్‌కోడ్‌ను నమోదు చేయండి!',
        congrats: 'అభినందన',
        taskUploadedSuccessfully: 'మీ పని విజయవంతంగా అప్‌లోడ్ చేయబడింది!',
        doYouReallyWantToAccept: 'మీరు ఈ పనిని అంగీకరించాలనుకుంటున్నారా?',
        doYouReallyWantToSumbit: 'మీరు ఈ పనిని సమర్పించాలనుకుంటున్నారా?',
        yes: 'అవును',
        no: 'తోబుట్టువుల',
        later: 'తర్వాత',
        updateYourSkill: 'Please update your profile to continue',
        notUpdatedYourTask: 'Because of some reason did not complete your task, please try again.',
        toProceedPleaseUpdateProfile: "పని అంగీకారంతో కొనసాగడానికి దయచేసి ప్రొఫైల్‌లో నైపుణ్యాలను నవీకరించండి",
        userNotAuthorized: 'user not authorized',
        alreadyAccepted: 'Already accepted',
        taskCompletionTime: 'టాస్క్ పూర్తి సమయం',
        goToProduct: 'పనికి వెళ్ళండి',
        getTask: 'టాస్క్ పొందండి',
        paymentSuccessFull: 'చెల్లింపు విజయవంతమైంది!',
        paymentUnSuccessFull: 'చెల్లింపు విఫలమైంది !',
        orderDetail: 'ఆర్డర్ వివరాలు',
        name: 'పూర్తి పేరు',
        OrderId: 'ఆర్డర్ Id',
        productName: 'వస్తువు పేరు',
        phoneNumber: 'మొబైల్ సంఖ్య',
        amount: 'మొత్తం',
        address: 'పూర్తి చిరునామా',
        pincode: 'పిన్ కోడ్',
        city: 'నగరం',
        state: 'రాష్ట్ర',
        postOffice: 'తపాలా కార్యాలయము',
        makecall: 'కాల్ చేయండి',
        callconnectMsg: 'Please wait while connecting call. Call will be initiated by this number {phoneNumber}.',
        orderAcceptedOrRejected: 'కస్టమర్ ఈ ఆర్డర్‌ను అంగీకరించారు లేదా తిరస్కరించారు ?',
        orderAccepted: 'ఆర్డర్ అంగీకరించబడింది',
        orderDenied: 'ఆర్డర్ తిరస్కరించబడింది',
        payRegisterationFees: 'రిజిస్ట్రేషన్ ఫీజు చెల్లించండి',
        retry: 'Retry',
        orderStatus: 'ఆర్డర్ స్థితి',
        callCompletedOrRejected: 'కాల్ ఆన్ ఆర్డర్ పూర్తయింది లేదా ?',
        callCompleted: 'కాల్ పూర్తయింది',
        callNotCompleted: 'కాల్ పూర్తి కాలేదు',
        callNotPicked: 'కాల్ తీసుకోలేదు',
        getNextTask: 'తదుపరి పనిని పొందండి',
        noMoreRecord:'ఎక్కువ రికార్డ్ లేదు',
        getTaskAllowedMsg: 'ఈ పనిని ఉదయం 9 గంటల నుండి 8 పిఎం వరకు మాత్రమే చేయవచ్చు',
        paymentMode: 'చెల్లింపు మోడ్',
        newTaskWillBeAvailable: 'కొంత సమయం లో కొత్త పని అందుబాటులో ఉంటుంది.',
        appBalanceChecked: 'అనువర్తన బ్యాలెన్స్ తనిఖీ చేయబడింది',
        appBalanceNotChecked: 'అనువర్తన బ్యాలెన్స్ తనిఖీ చేయబడలేదు',
        walletBalance: 'వాలెట్ బ్యాలెన్స్',
        mPointBalance: 'MPoints సంతులనం',
        userDetail: 'వినియోగదారు వివరాలు',
        notAvailable: 'అందుబాటులో లేదు',
        gameDownload: 'డౌన్‌లోడ్ చేస్తుంది',
        gameNotDownload: 'డౌన్‌లోడ్ చేయదు',
        choosePaymentOption: 'Choose payment option',
        fillRegistrationForm: 'Fill Registration form',
        registered: 'Registered',
        mall91AgentWillCallYou: 'Congratulations!! We have received your details. Mall91 Agent would contact you soon!',
        supportedPincode: 'Supported Pincode'

    }
}


const i18n = new VueI18n({
    locale: "hi", // set locale
    fallbackLocale: "hi", // set fallback locale
    messages // set locale messages
})

export default i18n